import React from 'react'
import { Person } from '@material-ui/icons'

export default {
  endpoint: 'account/reservation',
  shortLabel: 'invite',
  keys: { sortable: [] },
  loadStatus: (state) => state.loadStatus.invites,
  dataPanels: false,
  icon: <Person />,
}
